<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <div class="page-head q-mb-lg">
      <section class="widget-section widget-section--filter full-width flex no-wrap items-center q-mb-lg">
        <q-form ref="form" class="full-width">
          <div class="row no-wrap full-width q-col-gutter-sm q-mb-md">
            <div class="col flex no-wrap q-col-gutter-sm">
              <q-input
                v-model="filters.id"
                outlined
                @update:model-value="filterTable"
                label="ID"
                dense
                clearable
                class="full-width"
                @clear="reloadTable()"
              ></q-input>
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <q-input
                v-model="filters.uuid"
                @update:model-value="filterTable"
                label="UUID"
                outlined
                dense
                :rules="[validateUuid]"
                clearable
                class="full-width"
                @clear="reloadTable()"
              ></q-input>
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <DatePicker
                v-model="filters.dateFrom"
                @update:model-value="filterTable"
                label="Created after"
                class="full-width"
                @clear="
                  () => {
                    filters.dateFrom = undefined;
                  }
                "
              />
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <DatePicker
                v-model="filters.dateTo"
                @update:model-value="filterTable"
                label="Created before"
                class="full-width"
                @clear="
                  () => {
                    filters.dateTo = undefined;
                  }
                "
              />
            </div>
            <div class="col-2 flex no-wrap q-col-gutter-sm">
              <q-checkbox
                v-model="filters.deleted"
                @update:model-value="filterTable"
                label="Show deleted"
                class="full-width"
              />
            </div>
          </div>
          <div class="row no-wrap full-width q-col-gutter-sm">
            <div class="col flex no-wrap q-col-gutter-sm">
              <q-input
                v-model="filters.inputVariablesSchema"
                @update:model-value="filterTable"
                label="Input variables schema"
                outlined
                dense
                clearable
                class="full-width"
                @clear="reloadTable()"
              ></q-input>
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <q-input
                v-model="filters.authorizationSchema"
                @update:model-value="filterTable"
                label="Authorization schema"
                outlined
                dense
                clearable
                class="full-width"
                @clear="reloadTable()"
              ></q-input>
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <q-input
                v-model="filters.subSchemas"
                @update:model-value="filterTable"
                label="Sub schemas"
                outlined
                dense
                clearable
                class="full-width"
                @clear="reloadTable()"
              ></q-input>
            </div>
          </div>
        </q-form>
        <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
          <q-tooltip>Reset</q-tooltip>
        </q-icon>
      </section>
      <section class="widget-section widget-section--btn q-ml-md">
        <q-btn color="primary" @click="$router.push(`/blueprints/new`)" no-caps class="btn--no-hover"
          >New blueprint</q-btn
        >
      </section>
    </div>

    <section class="widget-section widget-section--table">
      <BlueprintsTable
        ref="blueprintsTable"
        :rowsPerPageOptions="[20, 50, 100]"
        class="fixed-table"
        :filters="filters"
        @confirmDeleteBlueprint="showConfirm($event)"
      />
    </section>
  </q-page>

  <q-dialog v-model="showConfirmDialog" class="single-service-page" persistent>
    <q-card style="min-width: 480px; border-radius: 0px">
      <q-toolbar class="shadow-2 q-py-sm q-px-md">
        <q-toolbar-title class="text-weight-bold">
          <strong>Delete Blueprint</strong>
        </q-toolbar-title>
        <q-btn
          icon="close"
          style="min-width: 20px"
          round
          flat
          class="btn--no-hover"
          @click="showConfirmDialog = false"
        ></q-btn>
      </q-toolbar>
      <q-card-section class="q-mx-md q-px-none q-pb-none" style="border-top: 2px solid var(--q-primary)">
        <p>Are you sure?</p>
      </q-card-section>
      <q-card-actions class="q-px-md q-pt-none q-pb-lg">
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          color="primary"
          text-color="text-color"
          :loading="deleteLoading"
          :disabled="deleteLoading"
          @click="deleteBlueprint"
          >Yes</q-btn
        >
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          class="btn--no-hover"
          flat
          @click="showConfirmDialog = false"
          >No</q-btn
        >
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import DatePicker from '../allItems/components/DatePicker.vue';
import BlueprintsTable from './components/BlueprintsTable.vue';
import { createWorkFlow } from '../registrations/api/api';

export default {
  name: 'BlueprintsPage',
  components: {
    DatePicker,
    BlueprintsTable,
  },
  data() {
    return {
      filters: {
        id: undefined,
        uuid: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        deleted: false,
        inputVariablesSchema: undefined,
        authorizationSchema: undefined,
        subSchemas: undefined,
      },
      loading: false,
      timeout: undefined,
      showConfirmDialog: false,
      currentBlueprint: undefined,
      deleteLoading: false,
    };
  },
  methods: {
    validateUuid(value) {
      const uuidRegex =
        // eslint-disable-next-line
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return value?.length ? uuidRegex.test(value) || 'Must be a valid UUID' : true;
    },
    async deleteBlueprint() {
      this.deleteLoading = true;
      const data = {
        workflowId: 'engprt.delete-blueprint',
        inputVariables: {
          uuid: this.currentBlueprint.uuid,
        },
      };
      try {
        await createWorkFlow(data);
        this.$notify('positive', 'Success', 'Blueprint will be deleted.');
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.deleteLoading = false;
        this.currentBlueprint = undefined;
        this.showConfirmDialog = false;
      }
    },
    showConfirm(blueprint) {
      this.currentBlueprint = blueprint;
      this.showConfirmDialog = true;
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.filters.deleted = false;
      this.reloadTable();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
    reloadTable() {
      this.$refs.blueprintsTable.reload();
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
      if (key === 'deleted') {
        this.filters[key] = query[key] === 'true';
      }
    });

    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.q-field--with-bottom {
  padding-bottom: 0 !important;
}
.widget-section {
  padding: 16px 16px 16px 5px;
  margin-bottom: 0;
}
.widget-section--btn {
  padding: 16px;
  min-width: 151px;
}
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showBanner {
  .fixed-table {
    height: calc(100vh - 360px);
  }
}
.fixed-table {
  height: calc(100vh - 300px);
}
.page-head {
  display: flex;
}
</style>
